import { Button, DatePicker, Drawer, Form, Input } from '@pankod/refine-antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export type BatchInfo = {
  batchNo: string;
  expirationDate?: string | null;
  notes?: string | null;
};

export const ProductBatchDrawer = ({
  open,
  batchInfo,
  onClose,
  onSave,
}: {
  open: boolean;
  batchInfo?: BatchInfo | null;
  onClose: () => void;
  onSave: (batchInfo: BatchInfo | null) => void;
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    if (batchInfo) {
      form.setFieldsValue({
        batchNo: batchInfo.batchNo,
        expirationDate: batchInfo.expirationDate ? dayjs(batchInfo.expirationDate) : null,
        notes: batchInfo.notes,
      });
    }
  }, [batchInfo, form]);

  const handleClose = () => {
    const { batchNo } = form.getFieldsValue() as BatchInfo;
    if (!batchNo) {
      onSave(null);
    }
    form.submit();
    onClose();
  };

  return (
    <Drawer
      title="Batch Tracking"
      placement="right"
      onClose={handleClose}
      visible={open}
      footer={
        <Button type="primary" onClick={() => form.submit()} style={{ width: '100%' }}>
          Save
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        scrollToFirstError
        onFinish={(values: BatchInfo) => {
          const { batchNo, expirationDate, notes } = values;
          onSave({
            batchNo,
            expirationDate: expirationDate
              ? dayjs(expirationDate).toDate().toISOString()
              : undefined,
            notes,
          });
          form.resetFields();
        }}
      >
        <Form.Item name="batchNo" label="Batch #" rules={[{ required: true }]}>
          <Input placeholder="e.g. PM-01" />
        </Form.Item>

        <Form.Item name="expirationDate" label="Expiration Date">
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="notes" label="Notes">
          <Input placeholder="e.g. Good" />
        </Form.Item>
      </Form>
    </Drawer>
  );
};
